import gql from 'graphql-tag';

export const RISK_LEVEL = gql`
    query RiskLevel($ticker: String!) {
        mutualFund(ticker: $ticker) {
            riskLevelName
            riskCategory
            riskSubCategory
            riskLevel
            ticker
            trpCode
        }
    }
`;
